import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { StoreListResponse } from '@api/models/dashboard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StoresData extends ApiServiceBase<StoreListResponse> {
  constructor() {
    super('managers', 'evoqAdmin');
  }

  fetchStores(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    filterBrand?: string;
    filterType?: string;
  }): Observable<StoreListResponse> {
    const query: Record<string, string | number> = {};

    if (params?.page) query['page'] = params.page;
    if (params?.pageSize) query['pageSize'] = params.pageSize;
    if (params?.search) query['search'] = params.search;
    if (params?.filterBrand) query['filter_brand'] = params.filterBrand;
    if (params?.filterType) query['filter_type'] = params.filterType;

    return this.read('me/stores', query);
  }
}
